'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Footer;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
    this.$element = (0, _jquery2.default)('.rn-footerMenu__sectionTitle');
    this.$sections = (0, _jquery2.default)('.rn-footerMenu__section');

    this.listExpandedClass = 'rn-footerMenu__section_expanded';

    this.init();
}

Footer.prototype.show = function (el) {
    (0, _jquery2.default)(el).parent().addClass(this.listExpandedClass);
};

Footer.prototype.hide = function () {
    this.$sections.removeClass(this.listExpandedClass);
};

Footer.prototype.toggle = function (el) {
    if ((0, _jquery2.default)(el).parent().hasClass(this.listExpandedClass)) {
        this.hide();
    } else {
        this.hide();
        this.show(el);
    }
};

Footer.prototype.init = function () {
    var self = this;
    (0, _jquery2.default)(window).on('rpBreakpointsSwitch', function (event) {
        if (![_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW].includes(event.detail.breakpoint.code)) {
            self.hide();
        }
    });
    this.$element.on('click', function () {
        if ([_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW].includes(_rpMqBreakpoints2.default.current().code)) {
            var target = this;
            self.toggle(target);
        }
    });

    /**
     * Bind footer click tracking event
     */
    (0, _jquery2.default)('.rn-footerMenu').on('click', function (event) {
        var $footerLinkItem = (0, _jquery2.default)(event.target);
        if ($footerLinkItem.hasClass('rn-footerMenu__listLink')) {
            var selection = $footerLinkItem.text().trim();
            segmentio.trackFooterClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, selection));
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/footer/footer.js
// module id = 1508
// module chunks = 0